import { LOGGED_OUT } from './auth';

// Actions
export const ALERT_SUCCESS = 'app/alert/SUCCESS';
export const ALERT_INFO = 'app/alert/INFO';
export const ALERT_WARNING = 'app/alert/WARNING';
export const ALERT_ERROR = 'app/alert/ERROR';
export const CLEAR_ALERT = 'app/alert/ALERT';

const initialState = {
  variant: null,
  icon: null,
  message: null,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ALERT_SUCCESS:
      return {
        ...state,
        variant: 'success',
        icon: 'check-circle',
        message: action.message,
      };

    case ALERT_INFO:
      return {
        ...state,
        variant: 'info',
        icon: 'info-circle',
        message: action.message,
      };

    case ALERT_WARNING:
      return {
        ...state,
        variant: 'warning',
        icon: 'exclamation-triangle',
        message: action.message,
      };

    case ALERT_ERROR:
      return {
        ...state,
        variant: 'danger',
        icon: 'exclamation-circle',
        message: action.message,
      };

    case CLEAR_ALERT:

    // eslint-disable-next-line no-fallthrough
    case LOGGED_OUT:
      return {
        ...state,
        icon: null,
        message: null,
      };

    default: return state;
  }
}

// Action Creators
export function alertSuccess(message) {
  return {
    type: ALERT_SUCCESS, message,
  };
}

export function alertInfo(message) {
  return {
    type: ALERT_INFO, message,
  };
}

export function alertWarning(message) {
  return {
    type: ALERT_WARNING, message,
  };
}

export function alertError(message) {
  return {
    type: ALERT_ERROR, message,
  };
}

export function clearAlert() {
  return { type: CLEAR_ALERT };
}
